<template>
  <div class="page_left_menu">
      <div :class="currentIndex == item.order?'menu_cell selected':'menu_cell'" v-for="(item,index) in menuListWihtPms" :key="index" @click="click_menu_item(item.order,item.path)">
        <img class="icon" :src="currentIndex == item.order?item.iconSelected:item.icon" />
        <span class="content">{{item.title}}</span>
      </div>
  </div>
</template>

<script>
import mixins  from "./Mixins"
export default {
  mixins:[mixins],
  data(){
    return {
      menuList:[
        { order:0,title:"统计", icon:require("@/assets/images/components/统计-默认.png"),iconSelected:require("@/assets/images/components/统计.png"), pms:false, path:"/statistics" },
        { order:1,title:"单位管理", icon:require("@/assets/images/components/单位管理-默认.png"),iconSelected:require("@/assets/images/components/单位管理.png"), pms:false, path:"/unit" },
        { order:2,title:"岗位管理", icon:require("@/assets/images/components/权限包-默认.png"),iconSelected:require("@/assets/images/components/权限包.png"), pms:false, path:"/permission" },
        { order:3,title:"运营帐号", icon:require("@/assets/images/components/运营帐号-默认.png"),iconSelected:require("@/assets/images/components/运营帐号.png"), pms:false, path:"/operation" },
        { order:4,title:"纪念堂管理", icon:require("@/assets/images/components/纪念堂管理-默认.png"),iconSelected:require("@/assets/images/components/纪念堂管理.png"), pms:false, path:"/space" },
        { order:5,title:"用户管理", icon:require("@/assets/images/components/用户管理-默认.png"),iconSelected:require("@/assets/images/components/用户管理.png"), pms:false, path:"/user" },
        { order:6,title:"线上订单", icon:require("@/assets/images/components/线上订单-默认.png"),iconSelected:require("@/assets/images/components/线上订单.png"), pms:false, path:"/order" },
        { order:7,title:"APP管理", icon:require("@/assets/images/components/线上订单-默认.png"),iconSelected:require("@/assets/images/components/线上订单.png"), pms:false, path:"/app" }
      ],
      pms:{
        statistics:false,
        unit:false,
        position:false,
        operator:false,
        space:false,
        user:false,
        order:false,
        app:false,
      }
    }
  },
  computed:{
    currentIndex() {
      return this.leftMenuIndex;
    },
    menuListWihtPms() {
      let list = [];
      this.menuList.forEach(item => {
        if(item.pms) {
          list.push(item)
        }
      })
    return list;
    }
  },
  created(){
    
    let pms = JSON.parse(window.sessionStorage.getItem("binyi_cms_pms"));
    this.menuList[0].pms = pms["10000"].check;
    this.menuList[1].pms = pms["20000"].check;
    this.menuList[2].pms = pms["30000"].check;
    this.menuList[3].pms = pms["40000"].check;
    this.menuList[4].pms = pms["50000"].check;
    this.menuList[5].pms = pms["60000"].check;
    this.menuList[6].pms = pms["70000"].check;
    this.menuList[7].pms = pms["80000"].check;
  },
  mounted(){
    this.ipad_height();
  },
  methods:{
    click_menu_item(index,path) {
      this.ipad_height();
      this.SET_LEFTMENU_INDEX(index);
      this.$router.push({
        path:path
      })
    },
    ipad_height(){
      console.log("ipad_height")
      //重新计算高度（横屏问题）
      let isIPad = /XiaoMi/.test(navigator.userAgent) || false;
      if (isIPad) {
        const mainBg = document.getElementsByClassName("mainBg");
        const mainBgNo = document.getElementsByClassName("mainBgNo");
        if (mainBg.length > 0) {
          mainBg[0].style.height = window.innerHeight - 80 + "px";
        } else if (mainBgNo.length > 0) {
          mainBgNo[0].style.height = window.innerHeight + "px";
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.page_left_menu {
  width: 250px;
  background-color: white;
  float  :left;
  .title {
    color :#000000;
    font-size:24px;
    font-weight :500;
    line-height :70px;
    text-align :center;
  }
  .menu_cell {
    height :50px;
    margin-bottom:10px;
    display:flex;
    align-items :center;
    background-color:#F7F8F9;
    cursor:pointer;
    box-sizing :border-box;
    border-left :5px solid #F7F8F9;
    font-weight :500;

    .content {
      color:#000000;

    }

    &.selected {
      background-color:#4EA2FF;
      border-left :5px solid #2775CD;

      .content {
      color:#FFFFFF;
      
    }
    }

    .icon {
      width:25px;
      height:25px;
      margin-left:35px;
      margin-right:15px;
    }
  }
  
}
</style>


// WEBPACK FOOTER //
// src/components/LeftMenu.vue